import React from 'react'
import {withRouter,Redirect} from "react-router";
import axios from 'axios';

import Spinner from '../../components/Widgets/Spinner';
import Logo from '../../assets/images/Crexendo VIP Logo_hi-res_300ppi.png';
import QRCode from "react-qr-code";

import '../../assets/css/style.css'
import Toast from '../../components/Widgets/CustomToast';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

class QrGenerator extends React.Component{

    state = {
        userName: "",
        signinLogo: localStorage.getItem("signin_logo"),
        password: "",
        cloud_id: "",
        loginValidationShow: false,
        toSignup: false,
        generating: false,
        qrModal: false,
        qrValue: '',
    }

    getLogos = () => {
        // on signin always get logos
        const payLoad = {
            base_url: window.location.origin,
        };
        axios.post(`${process.env.REACT_APP_SIMPLE_API_URL}getWhiteLabelOptions`, payLoad)
        .then(response => {
            localStorage.setItem("signin_logo",response.data.signin_logo);
            this.setState({signinLogo: response.data.signin_logo});
            localStorage.setItem("dashboard_logo",response.data.dashboard_logo);
            localStorage.setItem("custom_tab_background",response.data.custom_tab_background);
        }).catch(err => {
            console.log(err.response.data);
        });
    }
    componentDidMount(){
        this.getLogos();
        const url = new URL(window.location.href);
        const username = url.searchParams.get("username");
        let cloudId = url.searchParams.get("cloud_id");
        cloudId = cloudId.replace("*", "")
        this.setState({username: username});
        this.setState({cloudId: cloudId});
    }

    inputValueHandler = (evt) => {

            if(this.state.isAuthenticated)
            {
                this.setState({isAuthenticated: false});
            }
            this.setState({[evt.target.name]: evt.target.value});
            if(this.state.loginValidationShow){
                this.setState({loginValidationShow:false});
            }
    };

    qrCodeGenerator = (evt) => {
        evt.preventDefault();
        this.setState({generating: true});
        if(!this.state.username || !this.state.password )
        {
            this.setState({loginValidationShow:true});
            return;
        }
        const password = this.state.password;
        this.setState({password: password});
        const payLoad = {
            utype: 'u',
            cloud_username: this.state.username,
            cloud_password: password,
            cloud_id: this.state.cloudId
        }
        axios.post(`${process.env.REACT_APP_SIMPLE_API_URL}authUser`, payLoad)
        .then(response=>{
            this.setState({qrModal: true});
            //csc:username:password@CODE
            let qrValue = 'csc:' + this.state.username + ':';
                // convert password to base64
                const passwordBase64 = btoa(password);

            qrValue = qrValue +"V2=" + passwordBase64;
            qrValue = qrValue + '@' + this.state.cloudId;
            if(process.env.REACT_APP_ENVIRONMENT === "dev"){
                qrValue = qrValue + "*";
            }
            this.setState({qrValue: qrValue});
            
            this.setState({cloudPassword: this.state.password});
            this.setState({password: ''});
        })
        .catch(err=>{
            this.setState({loginValidationShow: true});
            this.setState({generating: false});
            this.setState({isAuthenticated: false});
            //alert(err);
        });

    }

    sendEmail = (evt) => {
        if(this.state.qrValue === ""){
            return;
        }
        this.setState({sendingEmail: true});
        const payLoad = new FormData();
        payLoad.append('user', this.state.username.split("@")[0]);
        payLoad.append('domain', this.state.username.split("@")[1]);
        payLoad.append('cloud_id', this.state.cloudId);

        axios.post(`${process.env.REACT_APP_API_URL}?format=json&object=subscriber&action=read&utype=${'u'}&cloud_username=${this.state.username}&cloud_password=${btoa(this.state.cloudPassword)}`, payLoad)
        .then(response=>{
            if(response.data[0]){
                const emailPayLoad = {
                    recepient: response.data[0].email,
                    name: response.data[0].first_name + " " + response.data[0].last_name,
                    qrValue: this.state.qrValue,
                    cloud_id: this.state.cloudId
                };

                if(emailPayLoad["recepient"] === "120@Saevolgo.ca"){
                    emailPayLoad["recepient"] = "daniyal@saevolgo.ca";
                }
        
                axios.post(`${process.env.REACT_APP_SIMPLE_API_URL}emailQR`, emailPayLoad)
                .then(response=>{
                    toast.success("Sucessfully sent email");
                    this.setState({sendingEmail: false});
                })
                .catch(err=>{
                    toast.error("Unable to send email");
                    this.setState({sendingEmail: false});
                });

            }
            else{
                Toast.error("No info on user found");
                this.setState({sendingEmail: false});
            }
        })
        .catch(err=>{
            Toast.error(err.message);
            this.setState({sendingEmail: false});
        });
    }
    render(){
        
        return(
            <div>
            
                <div className="auth-wrapper signUpBackgroundImage">
                    <div className="auth-content">
                        <div className="card">
                            <div class="col-md-12 theme-bg align-items-center justify-content-center custom-sigin-logo"
                                style={{textAlign: "center"}}>
                                <img src={this.state.signinLogo?process.env.REACT_APP_SIMPLE_API_URL + localStorage.getItem("signin_logo") : null} 
                                alt="lock images" class="img-fluid"/>
                            </div>
                            {
                                this.state.qrValue === ""? 
                                
                                    <div className="card-body text-center">
                                        <h3 className="mb-4">QR Generator</h3>
                                        <div className="input-group mb-3">
                                            <input type="text" className="form-control" placeholder="Username" disabled
                                            value={this.state.username} name="username" onChange={(evt) => this.inputValueHandler(evt)}/>
                                        </div>
                                        <div className="input-group mb-4">
                                            <input type="password" className="form-control" placeholder="Password"
                                            value={this.state.password} name="password" onChange={(evt) => this.inputValueHandler(evt)}/>
                                        </div>

                                        {
                                            this.state.loginValidationShow?
                                                <div className="mb-4">
                                                    <span className='login-error'>Invalid Password!</span>
                                                </div>
                                            :
                                                null
                                        }
                                    
                                        <button className="btn btn-primary mb-4 qrCustomBtn" onClick = {this.qrCodeGenerator}>
                                            {this.state.generating
                                                ? <Spinner data="" />
                                                : <FontAwesomeIcon icon={faQrcode} />
                                            }
                                        </button>

                                    </div>

                                : 

                                    <div className="card-body text-center">
                                        <h4>
                                            Hi {this.state.username},<br/>
                                        </h4>
                                        <hr/>
                                        <h5 className="mb-4">Please scan the below code to login</h5>
                                        <div className="input-group mb-3" style={{display: "block"}}>
                                            <QRCode value={this.state.qrValue}/>
                                        </div>
                                        <hr/>
                                        <h4>Thank you for using our App.</h4>
                                        <hr/>
                                        <button className="btn btn-primary mb-4 qrCustomBtn" onClick = {this.sendEmail}>
                                            {this.state.sendingEmail
                                                ? <Spinner data="Sending..." />
                                                : "Email QR Code"
                                            }
                                        </button>
                                    </div>

                                
                            }
                            
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default QrGenerator;